@if (videos?.length > 0) {
  <div [ngClass]="isCorporate ? 'bg-corporate-primary' : 'bg-primary'">
    <div class="container pb-4 pt-lg-4 pt-3">
      <div class="video-gallery">
        <div class="player-container">
          <div class="video-player">
            <fgb-media-player [video]="selectedVideo" />
          </div>
          <div class="video-info">
            <h5 class="video-title">{{ selectedVideo?.Title }}</h5>
            <p class="video-description" [innerHtml]="selectedVideo?.Description | markdownTranslate"></p>
          </div>
        </div>
        <div class="playlist-container">
          <fgb-media-playlist
            [videos]="videos"
            (playlistSelect)="onVideoSelect($event)"
            [selectedIndex]="selectedIndex"
          ></fgb-media-playlist>
        </div>
      </div>
    </div>
  </div>
}
